import { VehicleCancellationReason } from "types";

export const SECTION_MARGIN = 4;

// Get parameters
export const GET_PARAM_ID_CHANGE_SHEET = "idChangeSheet";
export const GET_PARAM_ID_ENVELOPE = "envelopeId";
export const GET_PARAM_EVENT = "event";

// Digisign
export const DIGISIGN_SUCCESS_EVENT_VALUE = "success";

// Modal
export const MODAL_UPLOAD_DOCUMENT = "CANCELLATION_MODAL_UPLOAD_DOCUMENT";
export const MODAL_UPLOAD_ATTACHMENT = "MODAL_UPLOAD_ATTACHMENT";

// Editable dates
export const EDITABLE_DATE_REASONS_CZ = [
    VehicleCancellationReason.BY_AGREEMENT,
    VehicleCancellationReason.REMOVED_FROM_REGISTER,
    VehicleCancellationReason.STOLEN_VEHICLE,
];

export const EDITABLE_DATE_REASONS_SK = [
    VehicleCancellationReason.BY_AGREEMENT,
    VehicleCancellationReason.REMOVED_FROM_REGISTER,
    VehicleCancellationReason.STOLEN_VEHICLE,
    VehicleCancellationReason.INSURER_DEATH,
    VehicleCancellationReason.CHANGE_OF_OWNERSHIP,
];
